module.exports = __webpack_public_path__ + "static/media/icon-close.608629c7.svg";